export const MAX_DDJJ_MB = 5
export const MAX_DDJJ_BYTES = MAX_DDJJ_MB * 1024 * 1024

// D4: incluye HEIC/HEIF de iPhone. Se valida por extensión porque en Windows el navegador
// suele informar file.type vacío para HEIC; el servicio vuelve a validar por contenido.
export const EXTENSIONES_DDJJ = ['.pdf', '.jpg', '.jpeg', '.png', '.heic', '.heif']
export const ACCEPT_DDJJ = EXTENSIONES_DDJJ.join(',')

export const MODAL_CARGA_DDJJ = {
  titulo: 'Cargar Declaración Jurada',
  bajada: 'Adjuntá el formulario firmado con tus datos y tu firma.',
  alerta:
    'Sin la Declaración Jurada no podrás ver la información médica.\n Una vez subido el documento, Provincia ART lo verificará.',
  template: {
    nombre: 'Declaración Jurada',
    tipo: 'PDF',
    link: 'Descargar',
    descargando: 'Descargando…',
    archivo: 'DDJJ Médicos portal WEB.pdf',
  },
  labelArchivo: 'Subir archivo',
  placeholder: 'Adjuntar el archivo',
  hintFormato: 'Admite archivos de imágenes o PDF',
  hintTamanio: `El archivo debe ser menor a ${MAX_DDJJ_MB}MB.`,
  cancelar: 'Cancelar',
  cargar: 'Cargar',
  cargando: 'Cargando…',
  // D6: mensaje del toast global de carga exitosa (MF02).
  exito: 'La Declaración Jurada fue cargada correctamente y se encuentra pendiente de aprobación.',
  errorGenerico: 'No pudimos cargar la Declaración Jurada. Intentá nuevamente.', // P2
  errorDescarga: 'No pudimos descargar la Declaración Jurada. Intentá nuevamente más tarde.', // P2
  // D9: sesión vencida al cargar o descargar (401).
  sesionVencida: 'Tu sesión expiró. Volvé a ingresar para cargar la Declaración Jurada.',
}

// Props de estilo de cada componente del DS que arma el modal (mockup del PBI 81147).
// ModalDdjj las combina por clave con las que recibe en `estilos`.
export const ESTILOS_MODAL_DDJJ = {
  contenido: { width: 'min(95vw, 640px)', height: 'auto', className: 'gap-4' }, // Modal.Content
  bajada: { variant: 'body1' }, // Text
  alerta: { variant: 'warning' }, // Alert
  // FileListItem del DS: classNames por slot (icon, fileName, badge, contentText, item, ...).
  // El ícono y el badge PDF los genera el propio componente a partir de fileType.
  filaTemplate: {
    classNames: {
      icon: 'text-primary-10',
      fileName: 'text-primary-10',
    },
  },
  labelArchivo: { variant: 'body2' }, // Text
  alertaError: { variant: 'error' }, // Alert de los errores de carga y descarga
  botonCancelar: { className: 'mr-4 h-9' }, // TextButton
  botonCargar: { size: 'small' }, // PrimaryButton
}
